import renderBenefitPlanPage from "../../../infrastructure/renders/BenefitPlanPage/render-benefit-plan-page";
import { findCompanyId } from "../../../infrastructure/repository/company-repository";
import { findFreshEmployeesWithFields } from "../../../infrastructure/employees-cache";
import findInStringCaseInsensitive from "../../../infrastructure/helpers/findInStringCaseInsensitive";
import { findModels } from "../../../infrastructure/repository/benefit-models-repository";

export default async function filterAvailableEmployees({
  benefitPlan,
  availableFilters,
  currentFilters,
  totalEmployees,
  searchValue = "",
  csvFilter = [],
}) {
  const companyId = await findCompanyId();
  const employees = await findFreshEmployeesWithFields(companyId);
  const { data: models } = await findModels();
  const modelId = models.find((model) => model.name === benefitPlan.name)?.id;

  const findInEmployeeAttributes = ({
    internalId,
    name,
    surname,
    legalId,
    email,
    search,
  }) => {
    return (
      findInStringCaseInsensitive({
        text: internalId,
        sample: search,
      }) ||
      findInStringCaseInsensitive({
        text: name,
        sample: search,
      }) ||
      findInStringCaseInsensitive({
        text: surname,
        sample: search,
      }) ||
      findInStringCaseInsensitive({
        text: email,
        sample: search,
      }) ||
      findInStringCaseInsensitive({
        text: legalId,
        sample: search,
      })
    );
  };

  const applySearch = (items) => {
    if (searchValue !== "") {
      return items.filter((employee) =>
        findInEmployeeAttributes({ ...employee, search: searchValue })
      );
    }
    return items;
  };

  const applyCsvFilter = (items) => {
    if (csvFilter?.length > 0) {
      return items.filter((employee) =>
        csvFilter.reduce(
          (acc, currentCsvFilter) =>
            acc ||
            findInEmployeeAttributes({ ...employee, search: currentCsvFilter }),
          false
        )
      );
    }
    return items;
  };

  const employeesWithoutRemoved = employees.filter(
    ({ state }) => state !== "removed"
  );

  const ignoreEmptyFilters = ({ keys, filterExpression }) =>
    filterExpression ||
    keys.reduce(
      (acc, currentKey) => acc && currentFilters[currentKey].length === 0,
      true
    );

  const filterKeys = Object.keys(currentFilters);

  const activeKeys = filterKeys.filter(
    (key) => currentFilters[key]?.length > 0
  );

  const employeeMatchesFilter = ({ employee, currentKey }) =>
    currentFilters[currentKey].includes(employee[currentKey]);

  const filteredEmployees = applySearch(
    applyCsvFilter(
      employeesWithoutRemoved.filter((employee) =>
        ignoreEmptyFilters({
          keys: filterKeys,
          filterExpression:
            activeKeys.reduce(
              (acc, currentKey) =>
                acc &&
                (employeeMatchesFilter({ employee, currentKey }) ||
                  (currentKey === "model" &&
                    currentFilters[currentKey].includes(employee.modelId))),
              true
            ) || filterKeys.length === 0,
        })
      )
    )
  );

  await renderBenefitPlanPage({
    benefitPlan,
    employees: filteredEmployees
      .filter(({ state }) => state !== "removed")
      .map((employee) => ({
        ...employee,
        checked: employee.modelId === modelId,
      })),
    availableFilters,
    currentFilters,
    totalEmployees,
    csvFilter,
  });
}
